/* eslint-disable */
/* this file is generated by generateIcons script */

import React from 'react'
import BaseIcon from '../../BaseIcon'

export default class TipsIcon extends BaseIcon {
  getChildren = () => [ <path d="M10.61,10H5.4A4.79,4.79,0,0,1,3,5.88,5,5,0,0,1,8,1a5,5,0,0,1,5,4.88A4.78,4.78,0,0,1,10.61,10ZM11,11v1H5V11Zm0,2.05A2.3,2.3,0,0,1,9.6,14c0,.57-.74,1-1.61,1s-1.57-.45-1.61-1A1.87,1.87,0,0,1,5,13.05V13h6Z" fill={this.getColor()}/> ]
  getViewBox = () => '0 0 16 16'
}
